import { render, staticRenderFns } from "./txt-secondary.vue?vue&type=template&id=74704aaf&scoped=true&"
import script from "./txt-secondary.vue?vue&type=script&lang=js&"
export * from "./txt-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74704aaf",
  null
  
)

export default component.exports